import { render, staticRenderFns } from "./uploads.vue?vue&type=template&id=24f0807c&scoped=true&"
import script from "./uploads.vue?vue&type=script&lang=js&"
export * from "./uploads.vue?vue&type=script&lang=js&"
import style0 from "./uploads.vue?vue&type=style&index=0&id=24f0807c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../ytht-h5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f0807c",
  null
  
)

export default component.exports